<script>
import ClickButton from 'linna/components/ClickButton'

import sound from '@/services/sound'

export default {
  name: 'StyledButton',

  components: {
    ClickButton
  },

  props: {

    sound: {
      default: true
    },

    pad: {
      default: true
    },

    color: {
      default: true
    },

    shortcut: {
      type: String,
      default: null
    },

    gamepad: {
      type: String,
      default: null
    },

    href: {},
    to: {},
    mailto: {},
    tel: {},
    external: {},
    noIndex: {},
    submit: {},
    tab: {},
    iconLeft: {},
    iconRight: {},
    loading: {},
    disabled: {}

  },

  computed: {

    gamepadkey () {
      if (this.gamepad) {
        return 'button-' + this.gamepad
      }

      return null
    },

    // We need to mess with some Vue internals to emit click events from both components and native form elements
    // https://vuejs.org/v2/guide/components-custom-events.html#Binding-Native-Events-to-Components
    normalizedListeners () {
      const listeners = {
        ...this.$listeners,
        click: this.onClick
      }

      if (this.shortcut) {
        listeners.shortkey = this.onClick
      }

      return listeners
    }

  },

  methods: {

    onClick () {
      if (this.sound) {
        sound.play('buttonPress1')
      }

      this.$emit('click')
    }

  }

}
</script>

<template>
  <click-button
    :href="href"
    :to="to"
    :mailto="mailto"
    :tel="tel"
    :external="external"
    :no-index="noIndex"
    :submit="submit"
    :tab="tab"
    :icon-left="iconLeft"
    :icon-right="iconRight"
    :loading="loading"
    :disabled="disabled"
    :class="{
      'c-styled-button-color': color,
      'c-styled-button-pad': pad,
      'c-styled-button-sound': sound
    }"
    class="c-styled-button"
    v-on="normalizedListeners"
    v-shortkey.once="shortcut ? [shortcut] : undefined"
    v-gamepad:[gamepadkey]="onClick"
    @shortkey="onClick"
  ><slot /></click-button>
</template>

<style lang="scss">

.c-styled-button-pad {
  @include pad-tight;
}

.c-styled-button {
  border-radius: 0.1rem;
}

.c-styled-button-color {

  &:hover,
  &:focus {
    @include transition-very-fast;
  }

  &.c-click-button-enabled {
    background-color: translucent($green, 0.05);

    &:hover {
      background-color: translucent($green, 0.15);
    }

    &:focus {
      background-color: translucent($green, 0.3);
    }

  }

}

</style>
